import copy from "@/services/copy";

function defaultInformations() {
    return {
        denomination: null,
        but: null,
        gouvernance: null,
        objet: null,
        domaine: null,
        theme: null,
        cooperative: null,
        dureeValidite: null,
        dureeRenouvellement: null,
        adresseCourriel: null,
        adresseSite: null,
        consentementCommunication: null,
        stipulations: null,
        precisionStipulation: null,
        adresse: {
            codePostal: null,
            commune: null,
            adresse: null,
            complementAdresse: null,
            pays: null,
        }

    };
}

function wrapComite(liste, type) {
    if (liste) {
        return liste.map(v => ({ ...v, type }));
    }
    return null;
}

function defaultComite() {
    return {
        morales: [],
        physiques: [],
        reprises: [],
    };
}

function defaultIndexMembres() {
    return [];
}

function defaultDocuments() {
    return [];
}


export default {
    namespaced: true,
    state: {
        informations: defaultInformations(),
        comite: defaultComite(),
        indexMembres: defaultIndexMembres(),
        dateDissolution: null,
        documents: defaultDocuments(),
        numero: null,
        fonction: null,
        juridiction: null,
        etat: null,
    },

    getters: {
        informations(state) {
            return state.informations;
        },
        comite(state) {
            return state.comite;
        },
        numero(state) {
            return state.numero;
        },
        fonction(state) {
            return state.fonction;
        },
        dateDissolution(state) {
            return state.dateDissolution;
        },
        indexMembres(state) {
            return state.indexMembres;
        },
        juridiction(state) {
            return state.juridiction;
        },
        documents(state) {
            return state.documents;
        },
        etat(state) {
            return state.etat;
        },
    },

    mutations: {
        clear(state) {
            state.informations = defaultInformations();
            state.comite = defaultComite();
            state.indexMembres = defaultIndexMembres();
            state.dateDissolution = null;
            state.documents = defaultDocuments();
            state.numero = null;
            state.juridiction =null;
            state.etat = null;
        },
        init(state, { numero, association,fonction, juridiction, dateDissolution }) {
            state.juridiction = juridiction;
            state.numero = numero;
            state.fonction = fonction;
            state.informations = association.informations;
            state.dateDissolution = dateDissolution;
            state.documents = copy(association.documents||[]);
            state.indexMembres = association.indexMembres;
            state.etat = association.etatAssociation;
            state.comite.physiques = wrapComite(association.physiques, "physique");
            state.comite.morales = wrapComite(association.morales, "morale");
            state.comite.reprises = wrapComite(association.reprises, "reprise");
        },

        fonction(state, {fonction }) {
            state.fonction = fonction;
        },
    },
}
